export default {
  PROVIDER_DETAILS_ERROR: {
    title: "There was an issue fetching the selected provider's details"
  },
  ESTIMATED_COST_ERROR: {
    title: 'There was an issue fetching the estimated visit cost for the selected provider.'
  },
  PROVIDER_DETAILS_NO_DATA: {
    title: 'There are no details for the selected provider.'
  }
};
